/**
 * <s-grid-view> — switch the collection grid between 1, 2 and 3 products per
 * row. The choice sits on <html data-grid-cols> so it survives filter and sort
 * refreshes, and is remembered on this device. Image sizes follow the choice
 * so photos stay sharp in the 1-per-row view.
 */
const KEY = 'distvnt:grid-cols';
const SIZES = {
  1: '(min-width: 768px) 640px, calc(100vw - 32px)',
  2: '(min-width: 1280px) 630px, calc((100vw - 36px) / 2)',
  3: '(min-width: 1280px) 420px, calc((100vw - 36px) / 3)',
};

const applySizes = (cols) => {
  document.querySelectorAll('#product-grid img[sizes]').forEach((img) => {
    if (!img.dataset.sizesDefault) img.dataset.sizesDefault = img.getAttribute('sizes');
    img.setAttribute('sizes', cols ? SIZES[cols] : img.dataset.sizesDefault);
  });
};

class SGridView extends HTMLElement {
  connectedCallback() {
    this.buttons = [...this.querySelectorAll('[data-grid-cols]')];
    let saved = null;
    try { saved = localStorage.getItem(KEY); } catch {}
    // With no saved choice, phones show 2 per row, so the knob starts there (not remembered).
    if (saved) this.set(saved, false);
    else if (window.matchMedia('(max-width: 1023.98px)').matches) this.set('2', false, false);
    this.buttons.forEach((b) => b.addEventListener('click', () => this.set(b.dataset.gridCols, true)));
    this.observer = new MutationObserver(() => applySizes(document.documentElement.dataset.gridCols));
    const grid = document.getElementById('product-grid');
    if (grid?.parentElement) this.observer.observe(grid.parentElement.parentElement || grid.parentElement, { childList: true, subtree: true });
  }

  disconnectedCallback() { this.observer?.disconnect(); }

  set(cols, animate, remember = true) {
    const swap = () => {
      document.documentElement.dataset.gridCols = cols;
      this.buttons.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.gridCols === cols)));
      applySizes(cols);
    };
    if (remember) { try { localStorage.setItem(KEY, cols); } catch {} }
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!animate || reduce || !document.startViewTransition || document.documentElement.dataset.gridCols === cols) { swap(); return; }
    // Cards on screen glide to their new spots instead of the whole page fading.
    const grid = document.getElementById('product-grid');
    const viewport = window.innerHeight;
    const cards = grid ? [...grid.children].filter((card) => {
      const box = card.getBoundingClientRect();
      return box.bottom > -viewport * 0.5 && box.top < viewport * 1.5;
    }).slice(0, 30) : [];
    cards.forEach((card, i) => { card.style.viewTransitionName = `grid-card-${i}`; });
    const root = document.documentElement;
    root.classList.add('is-grid-switching');
    const transition = document.startViewTransition(swap);
    transition.finished.finally(() => {
      cards.forEach((card) => { card.style.viewTransitionName = ''; });
      root.classList.remove('is-grid-switching');
    });
  }
}

if (!customElements.get('s-grid-view')) customElements.define('s-grid-view', SGridView);
